import { deleteTasks, updateTasks, createTask } from '../../../../features/tasks/store/tasksSlice';
import {
  addDependency,
  bulkDeleteDependency,
  updateDependencies,
} from '../../../../features/dependencies/store/dependenciesSlice';
import { formatTaskPayload, formatTaskResponse } from './formatter';
import store from '../../../../store';
import ganttStore from './ganttStore';

let dataProcessor = undefined;
let autoUpdateTimer = 0;
const pendingUpdates = { updateTasks: {}, deleteTasks: [], updateLinks: {}, deleteLinks: [] };

export const initGanttDataProcessor = (projectId, ganttId) => {
  const gantt = ganttStore.getGantt(ganttId);

  dataProcessor = gantt.createDataProcessor({
    task: {
      create: async (data) => {
        if (!data.isCreated) {
          return store
            .dispatch(createTask(formatTaskPayload(data, projectId)))
            .then((apiResponse) => {
              autoUpdate();
              return apiResponse.payload;
            });
        }
      },
      update: (data, id) => {
        if (id === -1) {
          return;
        }
        updateTask(data);
        autoUpdate();
      },
      delete: (id) => {
        deleteTask(id);
        autoUpdate();
      },
    },
    link: {
      create: async (data) => {
        if (!data.isCreated) {
          return store
            .dispatch(
              addDependency({
                source: data.source,
                target: data.target,
                type: data.type,
                lag: data.lag,
              })
            )
            .then((apiResponse) => {
              autoUpdate();
              return apiResponse.payload.data;
            });
        }
      },
      update: (data, id) => {
        updateLink(data);
        autoUpdate();
      },
      delete: (id) => {
        deleteLink(id);
        autoUpdate();
      },
    },
  });

  dataProcessor.attachEvent('onBeforeUpdate', function (id, state, data) {
    //Need to check if placeholder
    if (Object.keys(data).length <= 2 || data.type === gantt.config.types.placeholder) {
      return false;
    } else {
      return true;
    }
  });

  dataProcessor.attachEvent('onAfterUpdate', function (tempId, action, tid, response) {
    switch (action) {
      case 'inserted': {
        if (response && response.object_type == 'task' && tempId !== response.id) {
          gantt.changeTaskId(tempId, response.id);
          gantt.silent(function () {
            gantt.updateTask(response.id, { response });
          });
          // gantt.render();
          // gantt.showTask(response.id);
        }
        if (response && response.object_type == 'dependency' && tempId !== response.id) {
          if (gantt.isLinkExists(tempId)) {
            gantt.changeLinkId(tempId, response.id);
          }
        }
        break;
      }
      case 'error':
        break;
      default:
        break;
    }
  });
};

export const updateTask = (task) => {
  pendingUpdates.updateTasks[task.id] = formatTaskPayload(task);
};

export const deleteTask = (id) => {
  pendingUpdates.deleteTasks.push(id);
};

export const updateLink = (link) => {
  pendingUpdates.updateLinks[link.id] = link;
};

export const deleteLink = (id) => {
  pendingUpdates.deleteLinks.push(id);
};

const autoUpdate = () => {
  clearTimeout(autoUpdateTimer);
  autoUpdateTimer = setTimeout(async () => {
    processPendingUpdates();
  }, 500);
};

export const removeDataProcessorDefault = () => {
  if (dataProcessor) {
    dataProcessor.destructor();
    dataProcessor = null;
    clearTimeout(autoUpdateTimer);
    processPendingUpdates();
  }
};

const processPendingUpdates = async () => {
  if (pendingUpdates.updateTasks && Object.values(pendingUpdates.updateTasks)?.length) {
    store.dispatch(updateTasks(Object.values(pendingUpdates.updateTasks))).then(() => {
      pendingUpdates.updateTasks = {};
    });
  }

  if (pendingUpdates.deleteTasks && pendingUpdates.deleteTasks.length) {
    store.dispatch(deleteTasks({ tasks: pendingUpdates.deleteTasks })).then(() => {
      pendingUpdates.deleteTasks = [];
    });
  }

  if (pendingUpdates.updateLinks && Object.values(pendingUpdates.updateLinks)?.length) {
    store.dispatch(updateDependencies(Object.values(pendingUpdates.updateLinks))).then(() => {
      pendingUpdates.updateLinks = {};
    });
  }

  if (pendingUpdates.deleteLinks && pendingUpdates.deleteLinks.length) {
    store.dispatch(bulkDeleteDependency({ ids: pendingUpdates.deleteLinks })).then(() => {
      pendingUpdates.deleteLinks = [];
    });
  }
};
